<template>
  <div class="hero">
    <v-card-title class="header-title">
      🔍 Results related to 
      <span class="highlight">"{{ query }}"</span>
    </v-card-title>
    <PanelCompanies
      :page="pageCompanys"
      :length="totalPagesCompanys"
      :companies="companies"
      @onPageChange="changePage"
    />
  </div>
</template>
<script>
import apisCompanys from '@/apis/apisCompanys';
import PanelCompanies from '@/components/PanelCompanies.vue';


export default {
  name: 'SearchCompanysView',
  components: {
    PanelCompanies
  },
  data() {
    return {
      query: '',
      companies: [],
      pageCompanys: 1,
      totalPagesCompanys: 1
    };
  },
  created() {
    const query = this.$route.params.query;

    if (query) {
      this.query = query;
      apisCompanys.search(query,"","", this.pageCompanys - 1)
        .then(companies => {
          this.companies = companies.content
          this.totalPagesCompanys = companies.totalPages
          this.pageCompanys = companies.pageNumber  + 1; 
        })
        .catch(error => {
          console.error("Error fetching companies:", error);
        });
    }
  },
  methods: {
    changePage(page){
      // Con la busqueda arreglada, mandar texto vacio aqui devolvia el
      // directorio completo: al pasar de pagina se perdia lo que se busco.
      apisCompanys.search(this.query, "", "", page - 1)
        .then(companies => {
          this.companies = companies.content
          this.totalPagesCompanys = companies.totalPages
          this.pageCompanys = companies.pageNumber + 1; 
        })
    }
  }
}
</script>
<style scoped>

.header-title {
  background: linear-gradient(135deg, #102b65, #1e3a8a);
  color: #fff;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  letter-spacing: 0.5px;
}
.card-companies{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}
.ComponentCompany{
  flex: 1 1 calc(33.333% - 40px); /* Tres columnas con espacio entre ellas */
  box-sizing: border-box;
  max-width: calc(33.333% - 40px); /* Asegura que no exceda el ancho */
  border: 1px solid #ccc;
}

@media (max-width: 1200px) {
  .card-companies{
    display: flex;
    gap: 10px;

  }
  .ComponentCompany {
    flex: 1 1 calc(50% - 20px); /* Dos columnas en pantallas medianas */
    max-width: calc(50% - 20px);
  }
}

@media (max-width: 540px) {
  .card-companies{
    display: flex;
    gap: 10px;

  }
  .ComponentCompany {
    flex: 1 calc(100% - 20px); /* Dos columnas en pantallas medianas */
    max-width: calc(100% - 20px);
  }
}
</style>